import { UserFormType } from 'components';

export const createUserInitialValues: Partial<UserFormType> = {};
